<template>
  <main class="bmd-layout-content">
    <div class="row">
      <div class="container my-5">
        <!--Inicio collapse-->
        <div id="accordion">
          <div class="card">
            <div class="card-header" id="headingOne">
              <h5 class="mb-0">
                <button class="btn btn-link" data-toggle="collapse" data-target="#collapseOne" aria-expanded="false"
                        aria-controls="collapseOne">
                  USUARIOS
                </button>
              </h5>
            </div>

            <div id="collapseOne" class="collapse" aria-labelledby="headingOne" data-parent="#accordion">
              <div class="card-body">

                <div class="col-12">
                  <div class="row">
                    <div class="form-group col-12 col-md-3 col-sm-6">
                      <label for="exampleInputEmail1">Nombre del usuario</label>
                      <input type="email" class="form-control" id="exampleInputEmail1" aria-describedby="emailHelp"
                             placeholder="Ingrese el nombre" v-model="newUsuario.name">
                      <small id="emailHelp" class="form-text text-muted">Ejemplo: Juan Perez.</small>
                    </div>
                    <div class="form-group col-12 col-md-3 col-sm-6">
                      <label for="inputEmail1">Correo</label>
                      <input type="email" class="form-control" id="inputEmail1" aria-describedby="inputEmail1help"
                             placeholder="Ingrese el correo" v-model="newUsuario.email">
                      <small id="inputEmail1help" class="form-text text-muted">Ejemplo: juanperez@ejemplo.com.
                      </small>
                    </div>
                    <div class="form-group col-12 col-md-3 col-sm-6">
                      <label for="exampleInputpassword">Contraseña</label>
                      <input type="email" class="form-control" id="exampleInputpassword"
                             placeholder="Ingrese el nombre" v-model="newUsuario.password">
                    </div>
                    <div class="col-12 col-md-3 mt-sm-3 col-sm-6">
                      <select class="custom-select" v-model="newUsuario.rol">
                        <option value="regular" selected>Regular</option>
                        <option value="master">Master</option>
                      </select>
                    </div>
                    <button class="btn btn-outline-secondary pb-0 my-0 " @click="actualizarUsuario" type="button"
                            v-if="paginacionUsuarios.acciones.editar">Actualizar
                    </button>
                    <button type="submit" class="btn btn-primary" @click="guardarUsuario" v-else>Guardar</button>
                  </div>
                </div>
                <div class="table-responsive padreTabla">
                  <table class="table table-hover">
                    <thead>
                    <tr>
                      <th class="py-0" colspan="4">
                        <div class="col-4 col-sm-3 col-md-2 float-sm-right mx-0 px-0">
                          <select class="custom-select custom-select-sm " v-model="paginacionUsuarios.selected"
                                  @change="paginarUsuarios">
                            <option selected>Mostrar</option>
                            <option value="5">5</option>
                            <option value="10">10</option>
                            <option value="20">20</option>
                            <option value="25">25</option>
                            <option value="50">50</option>
                            <option value="100">100</option>
                            <option value="100000">Todos</option>
                          </select>
                        </div>
                      </th>
                    </tr>
                    <tr>
                      <th>Usuarios</th>
                      <th>Correo</th>
                      <th>Permiso</th>
                      <th colspan="2" class="text-center">Acciones</th>
                    </tr>
                    </thead>
                    <tbody>
                    <tr v-for="usuario in usuarios.data" class="py-1 my-0">
                      <td class="py-1 my-1">{{usuario.name}}</td>
                      <td class="py-1 my-1">{{usuario.email}}</td>
                      <td class="py-1 my-1">{{usuario.rol}}</td>
                      <td class="py-1 my-1 px-0 text-center">
                        <i class="far fa-edit botonAcciones mr-5" @click="editarUsuarios(usuario)" data-toggle="tooltip"
                           data-placement="left" title="Editar" :onmouseover="tooltop()">
                        </i>
                        <i class="far fa-trash-alt botonAcciones text-danger" @click="eliminarUsuarios(usuario)"
                           data-toggle="tooltip" data-placement="left" title="Eliminar" :onmouseover="tooltop()">
                        </i>
                      </td>
                    </tr>
                    </tbody>
                  </table>
                  <div class="btn-toolbar d-flex justify-content-center" role="toolbar"
                       aria-label="Toolbar with button groups">
                    <div class="btn-group mr-2" role="group" aria-label="First group">
                      <button type="button"
                              :class="{'disabled':paginacionUsuarios.paginacion.anterior,'btn btn-secondary':true}"
                              @click="cargarUsuarios(page={page: usuarios.current_page - 1})">
                        <i class="fas fa-arrow-left"></i> Atrás
                      </button>
                      <button type="button"
                              :class="{disabled:paginacionUsuarios.paginacion.siguiente,'btn btn-secondary':true}"
                              @click="cargarUsuarios(page= {page: usuarios.current_page + 1})">
                        Siguiente<i class="fas fa-arrow-right"></i></button>
                    </div>
                  </div>
                </div>

              </div>
            </div>
          </div>
          <div class="card">
            <div class="card-header" id="headingTwo">
              <h5 class="mb-0">
                <button class="btn btn-link collapsed" data-toggle="collapse" data-target="#collapseTwo"
                        aria-expanded="false" aria-controls="collapseTwo">
                  CLIENTES
                </button>
              </h5>
            </div>
            <div id="collapseTwo" class="collapse" aria-labelledby="headingTwo" data-parent="#accordion">
              <div class="card-body">

                <div class="col-12">
                  <div class="row">
                    <div class="form-group col-sm-6 col-12">
                      <label for="exampleInputCliente">Nombre cliente</label>
                      <input type="email" class="form-control" id="exampleInputCliente"
                             aria-describedby="emailHelpCliente"
                             placeholder="Ingrese el nombre del cliente" v-model="newCliente.nombre">
                      <small id="emailHelpCliente" class="form-text text-muted">Ejemplo: Txi Caribe</small>
                    </div>
                    <div class="mt-sm-3 col-sm-6 col-12">
                      <select class="custom-select" v-model="newCliente.user_id">
                        <option v-for="usuario in usuarios.data" v-bind:value="usuario.id">{{usuario.name}}</option>
                      </select>
                    </div>
                    <button class="btn btn-outline-secondary pb-0 my-0 " @click="actualizarCliente" type="button"
                            v-if="paginacionClientes.acciones.editar">Actualizar
                    </button>
                    <button type="submit" class="btn btn-primary" @click="guardarCliente" v-else>Guardar</button>
                  </div>
                </div>
                <div class="table-responsive padreTabla">
                  <table class="table table-hover">
                    <thead>
                    <tr>
                      <th class="py-0" colspan="4">
                        <div class="col-4 col-sm-3 col-md-2 float-sm-right mx-0 px-0">
                          <select class="custom-select custom-select-sm " v-model="paginacionClientes.selected"
                                  @change="paginarClientes">
                            <option selected>Mostrar</option>
                            <option value="5">5</option>
                            <option value="10">10</option>
                            <option value="20">20</option>
                            <option value="25">25</option>
                            <option value="50">50</option>
                            <option value="100">100</option>
                            <option value="100000">Todos</option>
                          </select>
                        </div>
                      </th>
                    </tr>
                    <tr>
                      <th>Cliente</th>
                      <th>Slug</th>
                      <th>Usuario</th>
                      <th>Rol</th>
                      <th colspan="2" class="text-center">Acciones</th>
                    </tr>
                    </thead>
                    <tbody>
                    <tr v-for="cliente in clientes.data" class="py-1 my-0">
                      <td class="py-1 my-1">{{cliente.nombre}}</td>
                      <td class="py-1 my-1">{{cliente.slug}}</td>
                      <td class="py-1 my-1">{{cliente.users[0].name}}</td>
                      <td class="py-1 my-1">{{cliente.users[0].rol}}</td>
                      <td class="py-1 my-1 px-0 text-center">
                        <i class="far fa-edit botonAcciones mr-5" @click="editarClientes(cliente)" data-toggle="tooltip"
                           data-placement="left" title="Editar" :onmouseover="tooltop()">
                        </i>
                        <i class="far fa-trash-alt botonAcciones text-danger" @click="eliminarClientes(cliente)"
                           data-toggle="tooltip" data-placement="left" title="Eliminar" :onmouseover="tooltop()">
                        </i>
                      </td>
                    </tr>
                    </tbody>
                  </table>
                  <div class="btn-toolbar d-flex justify-content-center" role="toolbar"
                       aria-label="Toolbar with button groups">
                    <div class="btn-group mr-2" role="group" aria-label="First group">
                      <button type="button"
                              :class="{'disabled':paginacionClientes.paginacion.anterior,'btn btn-secondary':true}"
                              @click="cargarClientes(page={page: usuarios.current_page - 1})">
                        <i class="fas fa-arrow-left"></i> Atrás
                      </button>
                      <button type="button"
                              :class="{disabled:paginacionClientes.paginacion.siguiente,'btn btn-secondary':true}"
                              @click="cargarClientes(page= {page: usuarios.current_page + 1})">
                        Siguiente<i class="fas fa-arrow-right"></i></button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="card">
            <!--<div class="card-header" id="headingThree">
              <h5 class="mb-0">
                <button class="btn btn-link collapsed" data-toggle="collapse" data-target="#collapseThree"
                        aria-expanded="false" aria-controls="collapseThree">
                  Collapsible Group Item #3
                </button>
              </h5>
            </div>
            <div id="collapseThree" class="collapse" aria-labelledby="headingThree" data-parent="#accordion">
              <div class="card-body">
                Anim pariatur cliche reprehenderit
              </div>
            </div>-->
          </div>
        </div>
        <!--Fin collapse-->

      </div>
    </div>
  </main>
</template>

<script>
  import servicioApi from '../servicioApi';

  export default {
    name: "administrador",
    data() {
      return {
        paginacionUsuarios: {
          paginacionParametros: {page: '', mostrar: ''},
          paginacion: {anterior: false, siguiente: false},
          selected: 'Mostrar',
          acciones: {editar: false}
        },
        usuarios: {},
        newUsuario: {rol: "regular", email: '', name: ''},
        paginacionClientes: {
          paginacionParametros: {page: '', mostrar: ''},
          paginacion: {anterior: false, siguiente: false},
          selected: 'Mostrar',
          acciones: {editar: false}
        },
        clientes: {},
        newCliente: {nombre: '', user_id: '1'},
      }
    },
    created() {
      if (this.paginacionUsuarios.selected == "Mostrar") {
        this.cargarUsuarios({page: 1, mostrar: 10});
      }
      if (this.paginacionClientes.selected == "Mostrar") {
        this.cargarClientes({page: 1, mostrar: 10});
      }
    },
    methods: {
      tooltop() {
        $(function () {
          $('[data-toggle="tooltip"]').tooltip()
        })
      },
      paginarUsuarios: function () {
        if (this.paginacionUsuarios.selected != 'Mostrar') {
          this.cargarUsuarios({mostrar: this.paginacionUsuarios.selected});
        } else
          this.cargarUsuarios({mostrar: null});
      },
      editarUsuarios: function (usuario) {
        this.newUsuario.name = usuario.name;
        this.newUsuario.email = usuario.email;
        this.newUsuario.rol = usuario.rol;
        this.newUsuario.id = usuario.id;
        this.paginacionUsuarios.acciones.editar = true;
      },
      guardarUsuario: function () {
        console.log(this.newUsuario);
        servicioApi.rol_admin.usuario.post(this.newUsuario).then(resp => {
          this.limpiarUsuario();
          this.cargarUsuarios(this.paginacionUsuarios.paginacionParametros)
        }).catch(error => {
          console.log(error);
        });
      },
      actualizarUsuario: function () {
        servicioApi.rol_admin.usuario.put(this.newUsuario).then(resp => {
          this.limpiarUsuario();
          this.paginacionUsuarios.acciones.editar = false;
          this.cargarUsuarios(this.paginacionUsuarios.paginacionParametros)
        }).catch(error => {
          console.log(error);
        });
      },
      eliminarUsuarios: function (usuario) {
        servicioApi.rol_admin.usuario.eliminar(usuario).then(resp => {
          this.cargarUsuarios(this.paginacionUsuarios.paginacionParametros);
        }).catch(error => {
          console.log(error);
        });
      },
      cargarUsuarios(parametro) {
        if (parametro.page > this.usuarios.last_page || parametro.page < 1)
          parametro.page = this.usuarios.last_page;
        else {
          if (this.paginacionUsuarios.selected != 'Mostrar') {
            parametro.mostrar = this.paginacionUsuarios.selected;
          }
          this.paginacionUsuarios.paginacionParametros = parametro;

          servicioApi.rol_admin.usuario.get(parametro).then(response => {
            this.usuarios = response.data.data;
            if (this.usuarios.current_page != undefined && this.usuarios.current_page == 1)
              this.paginacionUsuarios.paginacion.anterior = true;
            else
              this.paginacionUsuarios.paginacion.anterior = false;

            if (this.usuarios.current_page != undefined && this.usuarios.last_page != undefined && this.usuarios.last_page == this.usuarios.current_page)
              this.paginacionUsuarios.paginacion.siguiente = true;
            else
              this.paginacionUsuarios.paginacion.siguiente = false;
          }).catch(e => {
          });
        }
      },
      limpiarUsuario() {
        this.newUsuario.email = '';
        this.newUsuario.name = '';
        this.newUsuario.rol = '';
        this.newUsuario.password = '';
      },
      /*Clientes*/
      paginarClientes: function () {
        if (this.paginacionClientes.selected != 'Mostrar') {
          this.cargarClientes({mostrar: this.paginacionClientes.selected});
        } else
          this.cargarClientes({mostrar: null});
      },
      editarClientes: function (cliente) {
        this.newCliente.nombre = cliente.nombre;
        this.newCliente.user_id = cliente.user_id;
        this.newCliente.id = cliente.id;
        this.paginacionClientes.acciones.editar = true;
      },
      guardarCliente: function () {
        console.log(this.newCliente);
        servicioApi.rol_admin.cliente.post(this.newCliente).then(resp => {
          this.limpiarCliente();
          this.cargarClientes(this.paginacionClientes.paginacionParametros)
        }).catch(error => {
          console.log('error',error.response.data.data);
          alert(error.response.data.data);
          console.log(error);
        });
      },
      actualizarCliente: function () {
        servicioApi.rol_admin.cliente.put(this.newCliente).then(resp => {
          this.limpiarCliente();
          this.paginacionClientes.acciones.editar = false;
          this.cargarClientes(this.paginacionClientes.paginacionParametros)
        }).catch(error => {
          console.log(error);
        });
      },
      eliminarClientes: function (cliente) {
        servicioApi.rol_admin.cliente.eliminar(cliente).then(resp => {
          this.cargarClientes(this.paginacionClientes.paginacionParametros);
        }).catch(error => {
          console.log(error);
        });
      },
      cargarClientes(parametro) {
        if (parametro.page > this.clientes.last_page || parametro.page < 1)
          parametro.page = this.clientes.last_page;
        else {
          if (this.paginacionClientes.selected != 'Mostrar') {
            parametro.mostrar = this.paginacionClientes.selected;
          }
          this.paginacionClientes.paginacionParametros = parametro;

          servicioApi.rol_admin.cliente.get(parametro).then(response => {
            this.clientes = response.data.data;
            if (this.clientes.current_page != undefined && this.clientes.current_page == 1)
              this.paginacionClientes.paginacion.anterior = true;
            else
              this.paginacionClientes.paginacion.anterior = false;

            if (this.clientes.current_page != undefined && this.clientes.last_page != undefined && this.clientes.last_page == this.clientes.current_page)
              this.paginacionClientes.paginacion.siguiente = true;
            else
              this.paginacionClientes.paginacion.siguiente = false;
          }).catch(e => {
          });
        }
      },
      limpiarCliente() {
        this.newCliente.nombre = '';
      },
    }
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/privada/admin/administrador.vue